/**
 * åªè¦æä¸ä¸ªä¸æ»¡è¶³æ¡ä»¶å°±è¿å false
 * @param arr
 * @param func
 */
var every = function (arr, func) {
    for (var i = 0; i < arr.length; i++) {
        if (!func(arr[i], i))
            return false;
    }
    return true;
};
export default every;
//# sourceMappingURL=every.js.map